import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

const SUPPORTED_LOCALES = ['ar', 'en']

export function useLanguage() {
  const { locale, t } = useI18n()
  const route = useRoute()
  const router = useRouter()

  const currentLocale = computed(() => locale.value)
  const isRTL = computed(() => locale.value === 'ar')

  const applyLocaleToDocument = (lang) => {
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = lang
    document.title = t('meta.title')
  }

  const setLanguage = (lang) => {
    if (!SUPPORTED_LOCALES.includes(lang)) return
    locale.value = lang
    localStorage.setItem('locale', lang)
    applyLocaleToDocument(lang)
    if (route.params.lang !== lang) {
      router.push(`/${lang}`)
    }
  }

  const toggleLanguage = () => {
    setLanguage(locale.value === 'ar' ? 'en' : 'ar')
  }

  const initializeLanguage = () => {
    const routeLang = route.params.lang
    const lang = SUPPORTED_LOCALES.includes(routeLang) ? routeLang : 'ar'
    locale.value = lang
    localStorage.setItem('locale', lang)
    applyLocaleToDocument(lang)
  }

  watch(
    () => route.params.lang,
    (newLang) => {
      if (newLang && SUPPORTED_LOCALES.includes(newLang) && newLang !== locale.value) {
        locale.value = newLang
        localStorage.setItem('locale', newLang)
        applyLocaleToDocument(newLang)
      }
    }
  )

  return {
    locale: currentLocale,
    isRTL,
    initializeLanguage,
    setLanguage,
    toggleLanguage,
    t
  }
}
